const allCompaniesColumns = () => {
  return (
    [
      {
        Header: 'Id',
        accessor: 'id',
        editType: 'Number',
        options: []
      },

      {
        Header: 'Company Name',
        accessor: 'companyname',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Company Full Name',
        accessor: 'companyfullname',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Plant Code Name',
        accessor: 'plantcodename',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Schema Name',
        accessor: 'schemaname',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Location Code Name',
        accessor: 'locationcodename',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Address1',
        accessor: 'address1',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Address2',
        accessor: 'address2',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Address3',
        accessor: 'address3',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Province',
        accessor: 'province',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'State',
        accessor: 'state',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Country',
        accessor: 'country',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Continent',
        accessor: 'continent',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Zipcode',
        accessor: 'zipcode',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Contactno1',
        accessor: 'contactno1',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Contactno2',
        accessor: 'contactno2',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Active ?',
        accessor: 'isactive',
        editType: 'Boolean',
        options: []
      },
      {
        Header: 'Remarks',
        accessor: 'remarks',
        editType: 'inputField',
        options: []
      }

    ]
  )
}

export default allCompaniesColumns ;
